/* nh-cart-feedback.js | North Home light theme, Stage 2 (2026-10-31) + Stage 6A motion pass.
   Feedback only, never behaviour. After a SUCCESSFUL add to cart it puts .nh-added on the owner's buy-box
   button for 2.2 s (the van drives across, the tick draws itself, "Added"; CSS in nh-cart.css) and .nh-bump on
   the header cart icon for 0.6 s (bump + small wiggle). It listens to Shopify's standard cart event
   (CartLinesUpdateEvent, the same one Horizon's cart-icon and cart-drawer listen to, dispatched by the owner's
   buy box) and only attaches a second .then() to its promise: it never adds, changes, opens or closes anything.
   Stage 6A: any click on Check out (button#checkout: mouse, touch, Enter or Space) adds .nh-go for 1.7 s so the van
   drives across it. That listener is passive and never calls preventDefault: the form submits exactly as before.
   Fails silently. */
(function () {
  'use strict';
  function flash(el, cls, ms) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;             /* restart the CSS animation on rapid adds */
    el.classList.add(cls);
    clearTimeout(el['nh' + cls]);
    el['nh' + cls] = setTimeout(function () { el.classList.remove(cls); }, ms);
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#checkout') : null;
    if (b && !b.disabled) flash(b, 'nh-go', 1700);
  }, { capture: true, passive: true });
  /* The event name is StandardEvents.cartLinesUpdate from '@shopify/events'. It is written out as a string on
     purpose: Shopify's asset minifier rewrites a dynamic module import into a require call, which does not exist in the
     browser, so the old import-based listener never registered (found and fixed in stage 6A). */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.action !== 'add' || !e.promise) return;
    var src = e.target instanceof Element ? e.target : null;
    var btn = src && src.querySelector('[data-spa-atc]');
    e.promise.then(function (r) {
      if (r && r.detail && r.detail.didError) return;
      flash(btn, 'nh-added', 2200);
      document.querySelectorAll('cart-icon').forEach(function (i) { flash(i, 'nh-bump', 600); });
    }, function () {});
  });
})();
